import { Toolbar, Typography } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'

import './Profile.css'
import ProfileForm from './ProfileForm'
import { sales } from '../../../../../assets/icons'

const Profile = () => {
  const [selectedTab, setSelectedTab] = useState('General')
  const handleTabSwitch = (value) => {
    setSelectedTab(value)
  }
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Profile'} subtitle={'Profile'} />
      <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
        <div>
          <div
            className={`profile-tab-inner ${selectedTab === 'General' ? 'active-profile-tab' : ''}`}
            onClick={() => handleTabSwitch('General')}
          >
            <img src={sales} alt="" />
            <Typography whiteSpace={'nowrap'}>General Information</Typography>
          </div>
        </div>

        <div>
          <Typography className="dashboard-title">
            {selectedTab == 'General' ? 'General Information' : 'Security'}
          </Typography>
          {selectedTab == 'General' && <ProfileForm />}
        </div>
      </div>
    </div>
  )
}

export default Profile
